import { ParentContext } from 'global/cnr/contexts/ParentContext'
import UiSaveButtons from 'global/components/buttons/UiSaveButtons'
import AppForm from 'global/components/forms/appForms/AppForm'
import CopyPaste from 'global/components/pasting/CopyPaste'
import FullPageWrapper from 'global/wrappers/FullPageWrapper'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import _ from 'lodash'
import { useContext, useEffect, useState } from 'react'
import { golfAppForms } from '../helpers/golfFormProps'
import { _allowGolfUpdates } from '../useHelpers/useGolf'
import { useGolfers } from '../useHelpers/useGolfers'

const GolferAdd = ({ currentGolfer, handleCancel, currentGolfers, teams }) => {

  const [showPaste, setShowPaste] = useState()
  const [pastedGolfers, setPastedGolfers] = useState()
  const [_currentGolfer, setCurrentGolfer] = useState(_.cloneDeep(currentGolfer))
  const [golferReady, setGolferReady] = useState()
  const [missingGolfers, setMissingGolfers] = useState({})

  const { update_missingGolfers, create_golfer, update_handicaps, updating } = useGolfers()

  useEffect(() => {
    if (currentGolfers) {
      const missingGolfers = _.pickBy(
        currentGolfers,
        g => !g.firstName || !g.lastName
      )
      setMissingGolfers(missingGolfers);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [currentGolfers]);

  const isValid = (obj, items) => {
    return _.every(items, (key) => {
      return _.has(obj, key) && !_.isEmpty(_.trim(obj[key]));
    });
  };

  const handleMissingGolfers = async () => {
    update_missingGolfers({ missingGolfers })
  };

  const handleSaveHandicap = () => {
    create_golfer({ golfer: _currentGolfer })
  }

  const handleSaveHandicaps = async (golfers) => {
    update_handicaps({ golfers })
  };


  const handleUpdateGolfer = (d) => {
    console.log('d', d)
    setCurrentGolfer(d)
    setGolferReady(isValid(d, ['firstName', 'lastName', 'handicapIndex', 'handicapSourceType']))
  }

  const normalizePlayers = (input) => {
    if (_.isArray(input)) {
      return input;
    }
    if (_.isObject(input)) {
      return _.values(input); // extract objects from keys
    }
    return [];
  };

  const newGolfers = (ngs, egs) => {
    const playersA = normalizePlayers(ngs);
    const playersB = normalizePlayers(egs);
    return _.differenceWith(
      playersA,
      playersB,
      (a, b) =>
        _.toLower(a.firstName) === _.toLower(b.firstName) &&
        _.toLower(a.lastName) === _.toLower(b.lastName)
    );
  }

  const playersWithTeams = (players, existingTeams) =>
    _.map(players, (player) => {
      const matchedKeys = _.chain(existingTeams)
        .values()
        .filter((team) => _.toLower(team.name) === _.toLower(player.teamName))
        .map('_itemKey')
        .value();

      // explicitly omit teamName
      return {
        firstName: player.firstName,
        lastName: player.lastName,
        handicapIndex: 0,
        handicapSourceType: 'USGA',
        teams: matchedKeys
      };
    });


  const handlePasted = (golfers) => {
    const ngs2 = newGolfers(golfers, currentGolfers)
    const ngs1 = playersWithTeams(ngs2, teams)
    setPastedGolfers(ngs1)
    handleSaveHandicaps(ngs1)
    handleShowPaste()
  }

  const handleShowPaste = () => setShowPaste(!showPaste)

  const handleLocalPropChange = (d) => handleUpdateGolfer(d)
  const form_handlers = { handleFormDataChange_parent: handleLocalPropChange }

  const appForm_handicap = () => {
    const handicapFormItems = golfAppForms().golfer
    return <AppForm
      data_parent={_currentGolfer}
      appFormItems={handicapFormItems}
      form_handlers={form_handlers}
    />
  }

  const handicapFooter = () => {
    const btns = []
    btns.push({ oc: handleShowPaste, icon: 'arrow right', caption: 'Show Paste', color: 'blue', fl: true })
    btns.push({ oc: handleSaveHandicap, icon: 'save', caption: 'Add Golfer', color: _allowGolfUpdates ? 'green' : 'teal', disabled: !golferReady })
    btns.push({ oc: handleMissingGolfers, icon: 'delete', caption: 'Remove Golfers (' + _.size(missingGolfers) + ')', color: 'red', disabled: _.isEmpty(missingGolfers) })
    return <UiSaveButtons others={btns} />
  }

  const golfer_add = () => <Wrapper
    content={appForm_handicap()}
    wrapperType={wrapperTypes.padded}
    updating={updating}
    footer={handicapFooter()}
    css={{ header: 'glf-hdr', container: 'app-dark-mode', padding: '1em' }}
  />

  const fpw = () => <FullPageWrapper
    topperCaption={showPaste ? 'Add Golfers' : 'Add Golfer'}
    content={showPaste ? <CopyPaste handleCancel={handleShowPaste} handleUpdate={handlePasted} /> : golfer_add()}
    handleCancel={handleCancel}
  ></FullPageWrapper>

  return fpw()

}

export default GolferAdd